import { PageRequest } from '@/core/request/PageRequest';
import { PageResult } from '@/core/request/PageResult';

export enum SendOptionType {
  birthdays = 'BIRTHDAYS',
  futureServices = 'FUTURE_SERVICES',
  satisfactionSurvey = 'SATISFACTION_SURVEY',
  clientWithoutMovement = 'CLIENT_WITHOUT_MOVEMENT',
  recoveryOfDebts = 'RECOVERY_OF_DEBTS',
  emailMarketing = 'EMAIL_MARKETING',
  custom = 'CUSTOM',
  nextReviews = 'NEXT_REVIEWS',
}

export interface SendOption {
  body: string;
  id: number;
  quizId: number;
  subject: string;
  title: string;
  type: SendOptionType;
  systemDefaultType: boolean;
  matrixId: number;
}

// List

export interface ListSendOptionParams extends PageRequest {
  title?: string;
  subject?: string;
  matrixId?: number;
}

export type ListSendOptionResponse = PageResult<SendOption>;

// Create

export interface CreateSendOptionData {
  body: string;
  quizId: number;
  subject: string;
  systemDefaultType: boolean;
  title: string;
  type: SendOptionType;
  id?: number;
}

// Edit

export interface EditSendOptionData {
  title: string;
  body: string;
  subject: string;
  matrixId: number;
  type: SendOptionType;
  quizId: number;
}

export interface CrmSendOptionCommunication {
  sendOption: CreateSendOptionData;
  companyId: number;
  comunications: { customerId: number; email?: string }[];
}

export interface CrmSendOptionCommunicationWithVehicle {
  sendOption: CreateSendOptionData;
  companyId: number;
  comunicationsWithVehicles: {
    customerId: number;
    vehicleId?: number;
    email?: string;
  }[];
}

export interface CrmSendOptionCommunicationWithBilling {
  sendOption: CreateSendOptionData;
  companyId: number;
  billingComunications: {
    customerId: number;
    billsIds: number;
    email?: string;
  }[];
}

export interface CrmSendOptionFutureServiceCommunication {
  sendOption: CreateSendOptionData;
  companyId: number;
  futureServicesComunications: {
    customerId: number;
    futuresServicesIds: number[];
    vehicleId: number;
    email?: string;
  }[];
}

export interface CrmSendOptionNextReviewCommunication {
  sendOption: CreateSendOptionData;
  companyId: number;
  nextReviewsComunications: {
    customerId: number;
    vehicleId: number;
    vehicleItensIds: number[];
    email?: string;
  }[];
}
